import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { fetchJobCategoryData } from '../_api';
import AppWrappedStaticAutoComplete from '../../AppWrappedStaticAutoComplete';
import { EPIC_LINK_APP_ID } from '../_const';

/**
 * Job Category input component for Epic/EpicCare stylized to work with Custom App Request Form
 * @param {function} customFilter optional filter function to remove options from view
 * @param {Object} props properties
 * @returns Custom input
 */
const JobCategoryField = ({ customFilter = a => a, ...props }) => {
	const [originalOptions, setOriginalOptions] = useState([]);
	const [sLoading, setLoading] = useState(true);

	const roleDescriptionLink = useSelector(state => {
		const formIndex = Object.keys(state.apps.allForms).find(
			formIndex => state.apps.allForms[formIndex].id === EPIC_LINK_APP_ID
		);
		return formIndex
			? state.apps.allForms[formIndex].roleDescriptionLink
			: '';
	});

	useEffect(() => {
		let active = true;
		async function fetchApi() {
			const results = await fetchJobCategoryData('Link');

			const desiredOrder = [
				'Link Clinical Support Staff',
				'Link Site Administrator',
				'Link Medical Assistant',
				'Link Physician/APP',
				'Link Physician/APP and Site Administrator',
				'Link Continued Care And Services Coordinator',
				'Link EMT',
				'Link Biller',
				'Link Front Desk',
				'Link Study Monitor',
				'Link Psych/Social Professional',
				'Link School Nurse',
				'Link Sports Medicine Clinician',
				'Link Student Health Services Clinician',
				'Link Detention Center Clinician',
				'Link Requester',
				'Link Care Coordinator',
			];

			const processedResponse = Object.keys(results)
				.map(key => ({
					value: results[key],
					label: key,
				}))
				.filter(customFilter)
				.sort((a, b) => {
					const desiredOrderA =
						desiredOrder.indexOf(a.label) > -1
							? desiredOrder.indexOf(a.label)
							: desiredOrder.length;
					const desiredOrderB =
						desiredOrder.indexOf(b.label) > -1
							? desiredOrder.indexOf(b.label)
							: desiredOrder.length;
					return desiredOrderA - desiredOrderB;
				});
			setOriginalOptions(processedResponse);
			setLoading(false);
		}
		if (active) {
			fetchApi();
		}

		return () => {
			active = false;
		};
	}, [customFilter]);

	return (
		<AppWrappedStaticAutoComplete
			label={'Job Category'}
			sublabel='Type to search by job category name.'
			originalOptions={originalOptions}
			getValue={(options, value) => {
				return options.find(
					o => o.value.jobCategoryId === value.jobCategoryId
				);
			}}
			isLoading={sLoading}
			helperText={
				roleDescriptionLink && (
					<>
						Please refer to{' '}
						<a
							href={roleDescriptionLink}
							rel='noopener noreferrer'
							target='_blank'
						>
							this document
						</a>{' '}
						for a description of each EpicCare Link job categories.
					</>
				)
			}
			{...props}
		/>
	);
};

export default JobCategoryField;
